import React, { useEffect, useState } from "react";
import SyncIcon from "@mui/icons-material/Sync";
import { formatDistance } from "date-fns";
import { useDateFormatting } from "shared-ui/contexts/Locale/useDateFormatting";
import { TWChip, TWChipColor } from "apps/web/src/componentLibrary/TWChip/TWChip";

interface SyncStatusBadgeProps {
  lastSyncAt: Date;
  onRefresh: () => void;
}

export const SyncStatusBadge: React.FC<SyncStatusBadgeProps> = ({ lastSyncAt, onRefresh }) => {
  const { dateFnsLocale } = useDateFormatting();
  const [baseTime, setBaseTime] = useState(Date.now());
  const lastSyncTimestamp = new Date(lastSyncAt).getTime();

  useEffect(() => {
    const interval = setInterval(() => setBaseTime(Date.now()), 5000);
    return () => {
      clearInterval(interval);
    };
  }, [lastSyncTimestamp]);

  const timeAgoLabel = formatDistance(
    lastSyncTimestamp,
    lastSyncTimestamp - baseTime > 0 ? lastSyncTimestamp : baseTime,
    {
      includeSeconds: true,
      addSuffix: true,
      locale: dateFnsLocale,
    }
  );

  return (
    <TWChip
      label={`Last sync ${timeAgoLabel}`}
      chipColor={TWChipColor.blue}
      icon={<SyncIcon />}
      smLabel={true}
      sx={{ pr: 1.5, cursor: "pointer" }}
      onClick={onRefresh}
    />
  );
};
